
export const SERVER_URL = process.env.REACT_APP_API_SERVER_URL
export const FIREBASE_CONFIG = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

export const DashboardModules = {
	"KIOSK": "KIOSK",
	"STUDIO": "STUDIO",
	"ADMIN": "ADMIN",
	"HOME": "HOME",
}

export const KioskSubModules = {
	"MACHINE": "MACHINE",
	"INVENTORY": "INVENTORY",
	"TASKS": "TASKS",
	"OPERATIONS": "OPERATIONS",
	"ORDERS": "ORDERS",
	"OFFERS": "OFFERS",
	"BUSINESS": "BUSINESS",
}

export const StudioSubModules = {
	"INGREDIENT": "INGREDIENT",
	"RECIPE": "RECIPE",
	"DISH": "DISH",
}

export const AdminSubModules = {
	"LOGS": "LOGS",
}

/**
 * Logical URL bases per module (React Router path templates).
 * Kiosk lives under `/:machineId` (dynamic segment).
 */
export const DASHBOARD_MODULE_PREFIX = {
	[DashboardModules.KIOSK]: "/:machineId",
	[DashboardModules.STUDIO]: "/studio",
	[DashboardModules.ADMIN]: "/admin",
	[DashboardModules.HOME]: "/home",
}

export const KIOSK_SUBMODULE_PREFIX = {
	[KioskSubModules.MACHINE]: "",
	[KioskSubModules.INVENTORY]: "inventory",
	[KioskSubModules.TASKS]: "task",
	[KioskSubModules.OPERATIONS]: "xookeeper",
	[KioskSubModules.ORDERS]: "order",
	[KioskSubModules.OFFERS]: "offers",
	[KioskSubModules.BUSINESS]: "business",
}

/** Leading segment(s) under `/studio`. */
export const STUDIO_SUBMODULE_PREFIX = {
	[StudioSubModules.INGREDIENT]: "ingredient",
	[StudioSubModules.RECIPE]: "recipe",
	[StudioSubModules.DISH]: "dish",
}

export const ADMIN_SUBMODULE_PREFIX = {
	[AdminSubModules.LOGS]: "logs",
}

/** Kiosk + Studio sidebar keys → leading segment under the module base (for path inference). */
export const SUBMODULE_PATH_PREFIX = {
	...KIOSK_SUBMODULE_PREFIX,
	...STUDIO_SUBMODULE_PREFIX,
	...ADMIN_SUBMODULE_PREFIX,
	[DashboardModules.HOME]: "/home",
}

export const DASHBOARD_INDEX_PATH = "/";

export const AppRoutes = {
	[DashboardModules.HOME]: {
		INDEX: {
			path: "/",
			match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.HOME]}`,
			getPath: () => {
				return `/${DASHBOARD_MODULE_PREFIX[DashboardModules.HOME]}`
			},
		},
	},
	[DashboardModules.KIOSK]: {
		[KioskSubModules.MACHINE]: {
			INDEX: {
				path: "/",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}`,
				getPath: (machineId) => {
					return `/${machineId}`
				},
			},
			KITCHEN_MODULES: {
				path: "status",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/status`,
				getPath: (machineId) => {
					return `/${machineId}/status`
				},
			},
			GOD_MODE: {
				path: "godMode",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/godMode`,
				getPath: (machineId) => {
					return `/${machineId}/godMode`
				},
			},
			FOODMAKING: {
				path: "foodmaking",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/foodmaking`,
				getPath: (machineId) => {
					return `/${machineId}/foodmaking`
				},
			},
		},
		[KioskSubModules.INVENTORY]: {
			INVENTORY_SNAPSHOT: {
				path: "inventory",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/inventory`,
				getPath: (machineId) => {
					return `/${machineId}/inventory`
				},
			},
			REPLENISH: {
				path: "replenish",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/replenish`,
				getPath: (machineId) => {
					return `/${machineId}/replenish`
				},
			},
		},
		[KioskSubModules.TASKS]: {
			RECENT_TASKS: {
				path: "task/recent",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/task/recent`,
				getPath: (machineId) => {
					return `/${machineId}/task/recent`
				},
			},
			TASK: {
				path: "task/:taskId",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/task/:taskId`,
				getPath: (machineId, taskId) => {
					return `/${machineId}/task/${taskId}`
				},
			},
			ACTIVE_TASKS: {
				path: "task/active",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/task/active`,
				getPath: (machineId) => {
					return `/${machineId}/task/active`
				},
			},
			SEARCH_TASKS: {
				path: "task/search",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/task/search`,
				getPath: (machineId) => {
					return `/${machineId}/task/search`
				},
			},
		},
		[KioskSubModules.OPERATIONS]: {
			XOOKEEPER_PLANNED_TASKS: {
				path: "xookeeper/tasks/planned",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/xookeeper/tasks/planned`,
				getPath: (machineId) => {
					return `/${machineId}/xookeeper/tasks/planned`
				},
			},
			XOOKEEPER_PAST_TASKS: {
				path: "xookeeper/tasks/past",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/xookeeper/tasks/past`,
				getPath: (machineId) => {
					return `/${machineId}/xookeeper/tasks/past`
				},
			},
		},
		[KioskSubModules.ORDERS]: {
			RECENT_ORDERS: {
				path: "order/recent",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/order/recent`,
				getPath: (machineId) => {
					return `/${machineId}/order/recent`
				},
			},
			ORDER_DETAILS: {
				path: "order/details/:id",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/order/details/:id`,
				getPath: (machineId, orderId) => {
					return `/${machineId}/order/details/${orderId}`
				},
			},
		},
		[KioskSubModules.OFFERS]: {
			APPLY: {
				path: "offers/apply",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/offers/apply`,
				getPath: (machineId) => {
					return `/${machineId}/offers/apply`
				},
			},
		},
		[KioskSubModules.BUSINESS]: {
			BALANCE_SHEET: {
				path: "business/balance-sheet",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.KIOSK]}/business/balance-sheet`,
				getPath: (machineId) => {
					return `/${machineId}/business/balance-sheet`
				},
			},
		},
	},
	[DashboardModules.STUDIO]: {
		[StudioSubModules.INGREDIENT]: {
			INGREDIENT_LIST: {
				path: "ingredient",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/ingredient`,
				getPath: () => {
					return `/studio/ingredient`
				},
			},
			INGREDIENT_EDIT: {
				path: "ingredient/:id/edit",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/ingredient/:id/edit`,
				getPath: (ingredientId) => {
					return `/studio/ingredient/${ingredientId}/edit`
				},
			},
			INGREDIENT_DETAILS: {
				path: "ingredient/:id",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/ingredient/:id`,
				getPath: (ingredientId) => {
					return `/studio/ingredient/${ingredientId}`
				},
			},
			INGREDIENT_CREATE: {
				path: "ingredient/create",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/ingredient/create`,
				getPath: () => {
					return `/studio/ingredient/create`
				},
			},
		},
		[StudioSubModules.RECIPE]: {
			RECIPE_LIST: {
				path: "recipe",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/recipe`,
				getPath: () => {
					return `/studio/recipe`
				},
			},
			RECIPE_EDIT: {
				path: "recipe/:id/edit",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/recipe/:id/edit`,
				getPath: (recipeId) => {
					return `/studio/recipe/${recipeId}/edit`
				},
			},
			RECIPE_DETAILS: {
				path: "recipe/:id",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/recipe/:id`,
				getPath: (recipeId) => {
					return `/studio/recipe/${recipeId}`
				},
			},
			RECIPE_CREATE: {
				path: "recipe/create",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/recipe/create`,
				getPath: () => {
					return `/studio/recipe/create`
				},
			},
		},
		[StudioSubModules.DISH]: {
			DISH_LIST: {
				path: "dish",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/dish`,
				getPath: () => {
					return `/studio/dish`
				},
			},
			DISH_CREATE: {
				path: "dish/create",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/dish/create`,
				getPath: () => {
					return `/studio/dish/create`
				},
			},
			DISH_EDIT: {
				path: "dish/:id/edit",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/dish/:id/edit`,
				getPath: (dishId) => {
					return `/studio/dish/${dishId}/edit`
				},
			},
			DISH_DETAILS: {
				path: "dish/:id",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.STUDIO]}/dish/:id`,
				getPath: (dishId) => {
					return `/studio/dish/${dishId}`
				},
			},
		},
	},
	[DashboardModules.ADMIN]: {
		INDEX: {
			path: "",
			match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.ADMIN]}`,
			getPath: () => {
				return `/admin`
			},
		},
		[AdminSubModules.LOGS]: {
			AUDIT_LOGS: {
				path: "logs",
				match: `${DASHBOARD_MODULE_PREFIX[DashboardModules.ADMIN]}/logs`,
				getPath: () => {
					return `/admin/logs`;
				},
			},
		},
	},
}

export const KioskSidebarLinks = {
	"MACHINE": {
		"title": "Kiosk",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "oven_gen",
		"subLinks": [
			{
				"title": "Kitchen Modules",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].KITCHEN_MODULES,
				"isMaterialIcon": true,
				"icon": "apps"
			},
			{
				"title": "God Mode",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].GOD_MODE,
				"isMaterialIcon": true,
				"icon": "stadia_controller",
			},
			{
				"title": "Foodmaking",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].FOODMAKING,
				"isMaterialIcon": true,
				"icon": "task"
			},
		]
	},
	"INVENTORY": {
		"title": "Inventory",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "package_2",
		"subLinks": [
			{
				"title": "Snapshot",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.INVENTORY].INVENTORY_SNAPSHOT,
				"isMaterialIcon": true,
				"icon": "inventory_2"
			},
			{
				"title": "Replenish",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.INVENTORY].REPLENISH,
				"isMaterialIcon": true,
				"icon": "inventory"
			},
		]
	},
	"TASKS": {
		"title": "Tasks",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "add_task",
		"subLinks": [
			{
				"title": "Recent Tasks",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.TASKS].RECENT_TASKS,
				"isMaterialIcon": true,
				"icon": "list_alt"
			},
			{
				"title": "Search Tasks",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.TASKS].SEARCH_TASKS,
				"isMaterialIcon": true,
				"icon": "order_play"
			},
			{
				"title": "Active Tasks",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.TASKS].ACTIVE_TASKS,
				"isMaterialIcon": true,
				"icon": "order_play"
			}
		]
	},
	"OPERATIONS": {
		"title": "Operations",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "add_task",
		"subLinks": [
			{
				"title": "Xookeeper",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.OPERATIONS].XOOKEEPER_PLANNED_TASKS,
				"isMaterialIcon": true,
				"icon": "list_alt"
			}
		]
	},
	"ORDERS": {
		"title": "Orders",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "orders",
		"subLinks": [
			{
				"title": "Recent Orders",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.ORDERS].RECENT_ORDERS,
				"isMaterialIcon": true,
				"icon": "list_alt"
			},
		]
	},
	"OFFERS": {
		"title": "Offers",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "local_offer",
		"subLinks": [
			{
				"title": "Apply",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.OFFERS].APPLY,
				"isMaterialIcon": true,
				"icon": "upload_file"
			},
		]
	},
	"BUSINESS": {
		"title": "Business",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "account_balance",
		"subLinks": [
			{
				"title": "Balance Sheet",
				"route": AppRoutes[DashboardModules.KIOSK][KioskSubModules.BUSINESS].BALANCE_SHEET,
				"isMaterialIcon": true,
				"icon": "description"
			},
		]
	}
}

export const StudioSideBarLinks = {
	"INGREDIENT": {
		"title": "Ingredient",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "oven_gen",
		"subLinks": [
			{
				"title": "Ingredients List",
				"route": AppRoutes[DashboardModules.STUDIO][StudioSubModules.INGREDIENT].INGREDIENT_LIST,
				"isMaterialIcon": true,
				"icon": "apps"
			},
			{
				"title": "Create Ingredient",
				"route": AppRoutes[DashboardModules.STUDIO][StudioSubModules.INGREDIENT].INGREDIENT_CREATE,
				"isMaterialIcon": true,
				"icon": "stadia_controller",
			},
		]
	},
	"RECIPE": {
		"title": "Recipe",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "oven_gen",
		"subLinks": [
			{
				"title": "Recipes List",
				"route": AppRoutes[DashboardModules.STUDIO][StudioSubModules.RECIPE].RECIPE_LIST,
				"isMaterialIcon": true,
				"icon": "apps"
			},
			{
				"title": "Create Recipe",
				"route": AppRoutes[DashboardModules.STUDIO][StudioSubModules.RECIPE].RECIPE_CREATE,
				"isMaterialIcon": true,
				"icon": "stadia_controller",
			},
		]
	},
	"DISH": {
		"title": "Dish",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "restaurant",
		"subLinks": [
			{
				"title": "Dishes List",
				"route": AppRoutes[DashboardModules.STUDIO][StudioSubModules.DISH].DISH_LIST,
				"isMaterialIcon": true,
				"icon": "apps"
			},
			{
				"title": "Create Dish",
				"route": AppRoutes[DashboardModules.STUDIO][StudioSubModules.DISH].DISH_CREATE,
				"isMaterialIcon": true,
				"icon": "stadia_controller",
			},
		]
	}
}

export const AdminSidebarLinks = {
	"LOGS": {
		"title": "Audit",
		"hasSubLinks": true,
		"isMaterialIcon": true,
		"icon": "event",
		"subLinks": [
			{
				"title": "Logs",
				"route": AppRoutes[DashboardModules.ADMIN][AdminSubModules.LOGS].AUDIT_LOGS,
				"isMaterialIcon": true,
				"icon": "list_alt",
			},
		],
	},
}

export const MODULE_TO_SIDEBAR_LINKS = {
	[DashboardModules.KIOSK]: KioskSidebarLinks,
	[DashboardModules.STUDIO]: StudioSideBarLinks,
	[DashboardModules.ADMIN]: AdminSidebarLinks,
}